$(document).ready(function(){


  $('.s5_slider_row').slick({
    dots: true,
    slidesToShow:3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: true,
    centerMode: false,
    arrows:false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
        slidesToShow:2,
        slidesToScroll: 1,
        centerMode: true,
        }
      },
      
      {
        breakpoint: 767,
        settings: {
        slidesToShow:1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        arrows:true,
        }
      },
    ] 
  });

});